import { useQuery } from "@tanstack/react-query";
import { getDocument } from "../services/document.service";
import { Document } from "../types/document.types";
import { getDocumentInfo } from "../utils/document.utils";
import * as React from "react";

export const useDocument = () => {
  const [msWordId, setMsWordId] = React.useState<string | null>(null);

  React.useEffect(() => {
    const loadDocumentInfo = async () => {
      try {
        const docInfo = await getDocumentInfo();
        if (docInfo.id) {
          setMsWordId(docInfo.id);
        }
      } catch (error) {
        console.error("Failed to load document info:", error);
      }
    };

    loadDocumentInfo();
  }, []);

  return useQuery<Document>({
    queryKey: ["document", msWordId],
    queryFn: () => getDocument(msWordId!),
    enabled: !!msWordId,
    retry: false, // Don't retry on 404, we'll handle it manually
  });
};
